module.exports = __webpack_public_path__ + "static/media/MDPortals-logo-square.b9a6648c.png";